<template>
  <div class="rec-card-footer">
    <slot name="default" />
  </div>
</template>

<style scoped lang="scss">
.rec-card-footer {
  flex-grow: 0;
  margin-top: rem(20);
  display: flex;
  gap: rem(5);
}
</style>
